import {
  LoginArea,
  DropdownOpenDirection,
} from '@quicktools/shared-components/components/common/Login';

import analytics from '../../services/analytics';

import useStyles from './styles';

export default function SidebarLogin() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <LoginArea
        analytics={analytics}
        dropdownOpenDirection={DropdownOpenDirection.UP}
        loginButtonFullWidth
        showName
      />
    </div>
  );
}
